// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/turn-instrument-interpretation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/turn-instrument-interpretation/turn-coordinator-limits.js';
import g1 from '../lessons/aeronautics/turn-instrument-interpretation/turn-instrument-interpretation.js';

mount([g0, g1]);
